import { HubspotCompanySizeOptions, HubspotFieldNames } from '@/constants/hubspot';
import { CUSTOMER_STORIES_HOME, RESOURCES_HOME } from '@/constants/routes';
import { DEMO_REQUESTED_SESSION_KEY } from '@/constants/session-storage';
import { CUSTOMER_COUNT } from '@/constants/strings';
import { UserContext } from '@/context/user';
import { Maybe, ModuleSimpleCtaFooterFragment } from '@/graphql';
import SimpleCTAFooterModule from '@/modules/SimpleCTAFooter';
import { cloneDeep } from 'lodash';
import React, { FC, useContext, useMemo } from 'react';
import { useSessionstorageState } from 'rooks';

type ProductTourFooterProps = {
  props: Maybe<ModuleSimpleCtaFooterFragment>[] | undefined;
};

const ProductTourFooter: FC<ProductTourFooterProps> = ({ props: ogProps }) => {
  const { userData } = useContext(UserContext);
  const [didRequestDemo] = useSessionstorageState<boolean>(DEMO_REQUESTED_SESSION_KEY, false);

  const footerProps = useMemo(() => {
    let props: Maybe<ModuleSimpleCtaFooterFragment>[] | Maybe<ModuleSimpleCtaFooterFragment> | undefined =
      cloneDeep(ogProps);

    if (Array.isArray(props)) {
      props = props[0];
    }

    if (!props) return null;

    if (
      didRequestDemo &&
      !!userData[HubspotFieldNames.CompanySize] &&
      userData[HubspotFieldNames.CompanySize] !== HubspotCompanySizeOptions.XSmall
    ) {
      props.heading = `See how ${CUSTOMER_COUNT}+ businesses deliver exceptional service`;

      props.primaryCta = [
        {
          text: 'Read Customer Stories',
          url: CUSTOMER_STORIES_HOME,
        },
      ];

      props.secondaryCta = [
        {
          text: 'Explore Resources',
          url: RESOURCES_HOME,
        },
      ];
    }

    return props;
  }, [userData, ogProps]);

  return <SimpleCTAFooterModule props={footerProps} />;
};

export default ProductTourFooter;
